// @ts-nocheck
import $ from "jquery";

var $kundenart = $("#Kundenart");
var $meinGanterRegistrierung = $(":radio[name='MeinGanterRegistrierung']");
var $meinGanterRegistrierungZusatz = $("#mein-ganter-registrierung-zusatz");

// Die Felder Kundenname1, Kundenname2 und Abteilung sollen nur angezeigt werden, wenn die Kundenart Firma definiert ist.
if ($kundenart.length == 1) {
	setKundendatenKundenartControlStatus.call($kundenart);
	$kundenart.on("change", setKundendatenKundenartControlStatus);
}

$meinGanterRegistrierung.on("change", setMeinGanterRegistrierungZusatz);

// Setzt diverse Felder abhängig von der Kundenart (Privat/Firma)
// 1. Alles mit der Klasse .kundenart-firma wird bei privat ausgeblendet
// 2. Form-Container bekommt abhängig von der Kundenart eine andere CSS-Klasse
// 3. Postion der persönlichen Angaben verschiebt sich
function setKundendatenKundenartControlStatus() {
	var kundenart = $(this).val();
	var selectorFirma = ".kundenart-firma";
	var selectorPrivat = ".kundenart-privat";
	var selectorRegistrationFormStep = "#kundendaten-form-controls";

	if (kundenart == "Privat") { //2 => Privat
		$(selectorFirma).hide();
		$(selectorPrivat).show();
		$(selectorRegistrationFormStep).attr("class", "registration-form__step-2");
		// Bei "Privat" wandern die persönlichen Angaben unter die Kundenart
		$("#persoenliche-angaben").insertAfter("#kundenart-gruppe");
	} else {
		$(selectorFirma).show();
		$(selectorPrivat).hide();
		$(selectorRegistrationFormStep).attr("class", "registration-form__step-3");
		// Bei "Firma" sollen die persönlichen Angaben unter die Kontaktangaben
		$("#persoenliche-angaben").insertBefore("#kontaktangaben");
	}
}

// Blendet die zusätzlichen Felder (Kennwort, Newsletter-Info) die für eine Mein-Ganter-Registrierung benötigt werden ein bzw. aus
function setMeinGanterRegistrierungZusatz() {
	if ($(this).val() == "Ja") {
		$meinGanterRegistrierungZusatz.show();
	} else {
		$meinGanterRegistrierungZusatz.hide();
	}
}
